<template>
  <div style="z-index: 999999 !important; background-color: #ffffff">
    <!--  强制提醒   -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="cpfDialog"
      top="10vh"
      width="600px"
    >
      <div style="margin-bottom: 15px; color: #787a7d">
        {{ $t('customerManagements.invalidCPFAlert') }}
      </div>
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="ruleFormRule"
        label-width="auto"
        @submit.native.prevent
      >
        <el-form-item
          :label="$t('customerManagements.realName')"
          prop="realName"
          style="width: 95%"
        >
          <div class="dispatchName">{{ ruleForm.realName || '--' }}</div>
        </el-form-item>
        <el-form-item label="CPF" prop="cpf">
          <el-input
            v-model.trim="ruleForm.cpf"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            clearable
            style="width: 95%"
            @input="handleCnpjMother"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="submitFormCpf(1)"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button
          size="small" type="primary" @click="submitFormCpf(2)"
        >{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateAccountCpf } from '@/api/user';
import { checkCPF } from '@/utils/validate';

export default {
  data() {
    return {
      cpfDialog: false,
      ruleForm: {
        id: '',
        realName: '',
        cpf: ''
      },
      ruleFormRule: {
        cpf: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          { validator: checkCPF, trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  methods: {
    handleCnpjMother(val) {
      // 1. 移除所有非数字字符，只保留纯数字
      let cleaned = val.replace(/\D/g, '');

      // 2. 限制最大长度为11位（3+3+3+2 = 11位数字）
      if (cleaned.length > 11) {
        cleaned = cleaned.substring(0, 11);
      }
      // 3. 按格式分段拼接（xxx.xxx.xxx-xx）
      let formatted = '';
      const len = cleaned.length;
      if (len <= 3) {
        // 前3位：xxx
        formatted = cleaned;
      } else if (len <= 6) {
        // 4-6位：xxx.xxx
        formatted = `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
      } else if (len <= 9) {
        // 7-9位：xxx.xxx.xxx
        formatted = `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
      } else {
        // 10-11位：xxx.xxx.xxx-xx
        formatted = `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(
          6,
          9
        )}-${cleaned.slice(9, 11)}`;
      }
      // 4. 更新到表单
      this.ruleForm.cpf = formatted;
    },
    submitFormCpf(val) {
      if (val === 1) {
        this.cpfDialog = false;
      } else {
        this.$refs['ruleFormRef'].validate((valid) => {
          if (valid) {
            const data = {
              id: this.ruleForm.id,
              sourceType: 1,
              cpf: this.ruleForm.cpf
            };
            updateAccountCpf(data).then((res) => {
              if (res.code === 200) {
                if (res.data) {
                  this.cpfDialog = false;
                  this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                }
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    showCpf(arg) {
      this.$nextTick(() => {
        this.ruleForm.id = arg.id;
        this.ruleForm.realName = arg.realName;
        this.ruleForm.cpf = arg.cpf;
      });
      this.cpfDialog = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.dispatchName {
  width: 100%;
  height: 39px;
  border: 1px solid #dbdee5;
  padding-left: 10px;
  text-align: left;
  border-radius: 4px;
}
</style>
